import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { NgxTagCommanderModule } from 'ngx-tag-commander';
import { AbandonAccountsComponent } from './components/abandon-accounts/abandon-accounts.component';
import { CancelOpenBankingPopinComponent } from './components/cancel-open-banking-popin/cancel-open-banking-popin.component';
import { PopinComponent } from './components/popin/popin.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { DomChangeDirective } from './directives/dom-change/dom-change.directive';
import { ImgLoadDirective } from './directives/img-load/img-load.directive';
import { SpaceRemoverDirective } from './directives/input-format/space-remover.directive';
import { UpperCaseDirective } from './directives/input-format/upper-case.directive';
import { SpaceSeparatorPipe } from './pipes/space-separator/space-separator.pipe';
import { LoaderComponent } from './components/loader/loader.component';
import { LottieLoaderComponent } from './components/lottie-loader/lottie-loader.component';

@NgModule({
  declarations: [
    SidebarComponent,
    AbandonAccountsComponent,
    PopinComponent,
    CancelOpenBankingPopinComponent,
    DomChangeDirective,
    ImgLoadDirective,
    UpperCaseDirective,
    SpaceRemoverDirective,
    SpaceSeparatorPipe,
    LottieLoaderComponent,
    LoaderComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxTagCommanderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LottieComponent,
  ],
  exports: [
    TranslateModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgxTagCommanderModule,
    HttpClientModule,
    SidebarComponent,
    PopinComponent,
    CancelOpenBankingPopinComponent,
    AbandonAccountsComponent,
    DomChangeDirective,
    ImgLoadDirective,
    UpperCaseDirective,
    SpaceRemoverDirective,
    SpaceSeparatorPipe,
    LottieLoaderComponent,
    LoaderComponent,
  ],
  providers: [provideLottieOptions({ player: () => import('lottie-web') })],
})
export class SharedModule {
  constructor(translate: TranslateService) {
    translate.addLangs(['fr']);
    translate.setDefaultLang('fr');
    const allLangs = translate.getLangs();
    const browserLang = translate.getBrowserLang();

    if (browserLang != null && allLangs.includes(browserLang)) {
      translate.use(browserLang);
    }
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
